export default {"src":"/_next/static/media/engagement-retargeting.4ae94c2d.svg","height":1369,"width":1152,"blurWidth":0,"blurHeight":0};